import EADialog from "components/common/EADialog";
import i18next from "i18next";
import useStyles from "./ModalStyle";
import { useContext, useEffect, useState } from "react";
import { Context } from "states/Store";
import { ERROR } from "services/common/Constants";
import { getFinancialStatementsForThirdParty } from "services/edge/CreditsafeService";
import { formatDate, formatNumber, formatNumberCurrency } from "services/common/Utils";
import { Typography } from "@mui/material";
import { theme } from "style/globalStyle";
import { ArrowDownward, ArrowUpward } from "@mui/icons-material";
import { isEmpty } from "lodash";

const AdditionalFinancialDataModal = ({ thirdPartyId, isOpen, onClose }) => {
    const { classes } = useStyles();
    const [state, dispatch] = useContext(Context);
    const [financialStatements, setFinancialStatements] = useState();
    const [medianFinancialStatements, setMedianFinancialStatements] = useState();

    const get = async () => {
        try {
            const reponse = await getFinancialStatementsForThirdParty(state.account.id, thirdPartyId);
            if (!isEmpty(reponse.content)) {
                let keys = Object.keys(reponse.content);
                keys = keys.filter(function (item) {
                    return item !== 'median';
                })
                let formatedResult = [];
                for (let key of keys) {
                    formatedResult.push(reponse.content[key]);
                }
                setMedianFinancialStatements(reponse.content.median);
                setFinancialStatements(formatedResult.sort((a, b) => b.year - a.year));
            }
        } catch (error) {
            console.error(error);
            dispatch({
                type: "ALERT",
                alert: { type: ERROR, msg: error },
            });
        }
    }

    useEffect(() => {
        if (thirdPartyId && isOpen) {
            get(state.account.id, thirdPartyId);
        }
        // eslint-disable-next-line
    }, [state.account.id, thirdPartyId, isOpen])

    const display = (data, currency, percentage) => {
        if (percentage === 0 || percentage === null) {
            return <div style={{ display: "flex", justifyContent: "center" }}>{formatNumberCurrency(data, currency)}</div>;;
        } else if (percentage > 0) {
            return <div style={{ display: "flex", justifyContent: "center" }}>{formatNumberCurrency(data, currency)}
                <span className={classes.iconeEvolution} style={{ backgroundColor: theme.palette.primary.primary500 }}>
                    <ArrowUpward style={{ color: "#FFF", fontSize: "10px" }} />
                </span>
                <span style={{ color: theme.palette.primary.primary500 }}>{formatNumber(percentage, true)} %
                </span>
            </div>;
        } else {
            return <div style={{ display: "flex", justifyContent: "center" }}>{formatNumberCurrency(data, currency)}
                <span className={classes.iconeEvolution} style={{ backgroundColor: theme.palette.error.error600 }}>
                    <ArrowDownward style={{ color: "#FFF", fontSize: "10px" }} />
                </span>
                <span style={{ color: theme.palette.error.error600 }}>{formatNumber(percentage * -1, true)} %
                </span>
            </div>;
        }
    }

    return (
        <EADialog isOpen={isOpen} onClose={onClose} title={i18next.t("creditsafe.additionalFinancialData.title")} maxWidth="lg" hasActions={false}>
            {financialStatements ? (
                <>
                    <Typography className={classes.subTitle}>{i18next.t("creditsafe.additionalFinancialData.sig")}</Typography>
                    <div className={classes.gridColumns} style={{ marginBottom: "20px" }}>

                        <table>
                            <thead>
                                <tr style={{ height: "35px" }}>
                                    <th scope="col"></th>
                                    {financialStatements.map((item, index) => {
                                        return (
                                            <th scope="col" key={index}>{formatDate(item?.yearEndDate)}</th>
                                        )
                                    })}
                                    <th scope="col">{i18next.t("creditsafe.additionalFinancialData.median") + medianFinancialStatements?.year}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr style={{ height: "55px" }}>
                                    <th scope="row">{i18next.t("creditsafe.additionalFinancialData.grossOperatingSurplus")}</th>
                                    {financialStatements.map((item, index) => {
                                        return (
                                            <td key={index}>{display(item?.grossOperatingSurplus, item?.currencySymbol, item?.grossOperatingSurplusIncreasePercentage)}</td>
                                        )
                                    })}
                                    <td>{formatNumberCurrency(medianFinancialStatements?.grossOperatingSurplus, medianFinancialStatements?.currencySymbol)}</td>
                                </tr>
                                <tr style={{ height: "55px" }}>
                                    <th scope="row">{i18next.t("creditsafe.additionalFinancialData.netResult")}</th>
                                    {financialStatements.map((item, index) => {
                                        return (
                                            <td key={index}>{display(item?.netResult, item?.currencySymbol, item?.netResultIncreasePercentage)}</td>
                                        )
                                    })}
                                    <td>{formatNumberCurrency(medianFinancialStatements?.netResult, medianFinancialStatements?.currencySymbol)}</td>
                                </tr>
                                <tr style={{ height: "55px" }}>
                                    <th scope="row">{i18next.t("creditsafe.additionalFinancialData.turnover")}</th>
                                    {financialStatements.map((item, index) => {
                                        return (
                                            <td key={index}>{display(item?.turnover, item?.currencySymbol, item?.turnoverIncreasePercentage)}</td>
                                        )
                                    })}
                                    <td>{formatNumberCurrency(medianFinancialStatements?.turnover, medianFinancialStatements?.currencySymbol)}</td>
                                </tr>
                            </tbody>

                        </table>
                    </div>
                    
                    <Typography className={classes.subTitle}>{i18next.t("creditsafe.additionalFinancialData.bilan")}</Typography>
                    <div className={classes.gridColumns}>
                        <table>
                            <thead>
                                <tr style={{ height: "35px" }}>
                                    <th scope="col"></th>
                                    {financialStatements.map((item, index) => {
                                        return (
                                            <th scope="col" key={index}>{formatDate(item?.yearEndDate)}</th>
                                        )
                                    })}
                                    <th scope="col">{i18next.t("creditsafe.additionalFinancialData.median") + medianFinancialStatements?.year}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr style={{ height: "55px" }}>
                                    <th scope="row">{i18next.t("creditsafe.additionalFinancialData.shareholdersEquity")}</th>
                                    {financialStatements.map((item, index) => {
                                        return (
                                            <td key={index}>{display(item?.shareholdersEquity, item?.currencySymbol, item?.shareholdersEquityIncreasePercentage)}</td>
                                        )
                                    })}
                                    <td>{formatNumberCurrency(medianFinancialStatements?.shareholdersEquity, medianFinancialStatements?.currencySymbol)}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </>
            ) : (
                <Typography className={classes.noDataMessage}>{i18next.t("creditsafe.additionalFinancialData.noData")}</Typography>
            )}
        </EADialog>
    )

}
export default AdditionalFinancialDataModal;